module.exports = __webpack_public_path__ + "static/media/hall-PB.f1f86dcc.svg";